type Variant = "content" | "fullscreen";

/** Non-blocking skeleton while lazy route chunks load — keeps shells visible (variant `content`). */
export function RoutePageFallback({ variant = "content" }: { variant?: Variant }) {
  const fullscreen = variant === "fullscreen";
  return (
    <div
      className={
        fullscreen
          ? "flex min-h-screen w-full flex-col items-center justify-center bg-[var(--color-bg)]"
          : "flex min-h-[50vh] w-full flex-col items-center justify-center px-6 py-12"
      }
      role="status"
      aria-busy="true"
      aria-label="Loading page"
    >
      <div
        className="h-1 max-w-[8rem] w-full animate-pulse bg-[var(--border-default)]"
        style={{ clipPath: "polygon(4px 0, 100% 0, 100% calc(100% - 4px), calc(100% - 4px) 100%, 0 100%, 0 4px)" }}
      />
      <span className="sr-only">Loading…</span>
    </div>
  );
}
